import TicketCreateExternalThreats from './TicketCreateExternalThreats';

export default TicketCreateExternalThreats;
